<template>
    <div @click="scrollToTop()">
        <b-button :variant="variant" :size="size">
            <b-icon-chevron-compact-up class="mt-1" />
        </b-button>
    </div>
</template>

<script>

    export default {
        name: "ScrollTopButton",
        props: {
            variant: String,
            size: String
        },
        methods:{
            scrollToTop() {
                window.scrollTo(0,0);
           }
        }
    }
</script>
